import SDK from "../../config";
import axios from "axios";
import toast from "react-hot-toast";
import postVisitorsData from "../web/visitors";
import SubscriptionService from "../../services/subscriptionService";

const handlePaymentSuccess = async ({
  setupIntentId,
  paymentMethodId,
  paymentMethodType,
  cardHolderName,
  customerEmail,
  // customerPhone,
  billingZipcode,
  platformUsed,
  customerId,
  navigate,
}) => {
  const tagsString = "IOS,RESERVED";
  const queryParams = new URLSearchParams({
    email_address: customerEmail,
    status: "subscribed",
    tags: tagsString,
    first_name: cardHolderName,
    // phone_number: customerPhone,
    AddToCart: "1",
    reserved: "1",
  });

  try {
    // Track purchase event using Facebook Pixel if available
    if (window.fbq) {
      window.fbq("track", "Purchase", {
        value: SDK.FB_PRICE,
        currency: SDK.FB_CURRNECY,
      });
    }

      // Purchase Tracker
      if (window.twq) {
      window.twq("event", "tw-qmokf-qmokg", {
        value: SDK.FB_PRICE,
        currency: SDK.FB_CURRNECY,
      });
    }

    // Track complete payment event using TikTok Pixel if available
    // if (window.ttq) {
    //   window.ttq.track("CompletePayment");
    // }

    const userCardData = {
      setupIntentId,
      paymentMethodId,
      paymentMethodType,
      cardHolderName,
      customerEmail,
      // customerPhone,
      billingZipcode,
      platformUsed,
      customerId,
    };
    const paymentIntentResponse = await SubscriptionService.createSubscription(
      userCardData
    );

    const queryString = queryParams.toString();
    await axios.post(`${SDK.BASE_URL}/api/post_email_mailchimp?${queryString}`);

    const lead = true;
    const addtocart = true;
    const purchase = true;
    const amount = SDK.FB_PRICE;
    postVisitorsData({
      email: customerEmail,
      lead,
      addtocart,
      purchase,
      amount,
      tags: tagsString,
    });
    // Check if saving payment intent was successful
    if (paymentIntentResponse === "Payment failed") {
      toast.error("Failed to save payment details.");
      return false;
    } else {
      navigate(`/confirmation?email=${encodeURIComponent(customerEmail)}`);
      return true;
    }
  } catch (error) {
    toast.error("Please try again.");
  }
};

export default handlePaymentSuccess;
